<ngb-toast *ngFor="let toast of toastService.toasts"
           [class]="toast.classname"
           [autohide]="true"
           [delay]="toast.delay || 5000"
           (hidden)="toastService.remove(toast)">
    {{ toast.textOrTpl }}
</ngb-toast>